import { createSlice } from '@reduxjs/toolkit'
import { CompanyAccount, LoginResult } from '../../constants/users'

const initialUser: CompanyAccount | null = (() => {
    const item = window.sessionStorage.getItem('_p_user');
    if (item === null) {
        return null;
    }

    const user: CompanyAccount = JSON.parse(item);
    return user;
})();

const initialState = {
    value: initialUser,
    status: 'idle',
}
type UserType = {
    value: LoginResult | null
    status: string
}
type Login = (state: UserType, action: { payload: LoginResult }) => void
type loginoutType = (state: UserType) => void

// 创建reducer以及action
export const userSlice = createSlice<UserType, { login: Login; loginout: loginoutType }, string>({
    name: 'User',
    initialState,
    reducers: {
        login: (state, action) => {
            state.value = { ...action.payload }
            window.sessionStorage.setItem('_p_user', JSON.stringify(action.payload));
        },
        loginout: (state) => {
            window.sessionStorage.removeItem('_p_user');
            state.value = null
            window.location.pathname = "/"
        },
    },
})

// 查询数据
export const getUser = (state: { User: UserType }) => state.User.value


export const { login, loginout } = userSlice.actions
export default userSlice.reducer
